import {useRoutes} from 'react-router-dom'
import PropTypes from 'prop-types'

const RouteWithSubRoutes = ({routerConfig}) => {
  const routes = useRoutes(routerConfig)

  return (
    <>
      {routes}
    </>
  )
}

RouteWithSubRoutes.propTypes = {
  routerConfig: PropTypes.array.isRequired
}

export default RouteWithSubRoutes
